import { t } from 'i18next';
import z from 'zod';
import { sectionContextSchema } from './section-context-schema';

/**
 * A company is a root section (see {@link sectionContextSchema}) plus its own
 * relations — a required primary customer and optional company admins.
 */
export const companyFormSchema = sectionContextSchema.extend({
  primary_customer_id: z.string().nonempty(t('errors:forms.string.non_empty')),
  company_admin_ids: z.array(z.string()),
});

export type CompanyFormValues = z.input<typeof companyFormSchema>;
export type CompanyFormValidated = z.output<typeof companyFormSchema>;
